import OrderProductCard from './OrderProductCard';

export default OrderProductCard;
